import {
  LIBRARY_ASSIST_BASE,
  POST_ANALYSES_BASE,
  adsAssistantClientFetch,
  type AdsAssistantFetchResult,
} from "./adsAssistantClientHttp";
import type {
  AdsLibraryAssistDraft,
  AdsLibraryAssistTarget,
  AdsAssistantPostAnalysisRow,
} from "./adsAssistantClientTypes";

export async function listAdsPostAnalyses(
  socialPostId: string
): Promise<AdsAssistantFetchResult<{ ok: true; analyses: AdsAssistantPostAnalysisRow[] }>> {
  const q = `?social_post_id=${encodeURIComponent(socialPostId)}`;
  return adsAssistantClientFetch(`${POST_ANALYSES_BASE}${q}`, { method: "GET" });
}

export async function assistAdsLibraryDraft(body: {
  intent: string;
  pastedAd?: string;
  target?: AdsLibraryAssistTarget;
  includeSampleAdCopy?: boolean;
  /** 1–5 saved post ids; server loads caption text (must match examplePlatform when set). */
  exampleSocialPostIds?: string[];
  /** Lowercase platform key; required when using example bank picker consistency checks. */
  examplePlatform?: string;
  /** Slice 19e — up to 5 trainer-written exemplar captions (text only; no source post). */
  customExemplarTexts?: string[];
}): Promise<AdsAssistantFetchResult<{ ok: true; draft: AdsLibraryAssistDraft; notes?: string }>> {
  return adsAssistantClientFetch(LIBRARY_ASSIST_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      intent: body.intent,
      pastedAd: body.pastedAd ?? "",
      target: body.target ?? "auto",
      includeSampleAdCopy: body.includeSampleAdCopy === true,
      exampleSocialPostIds: body.exampleSocialPostIds ?? [],
      examplePlatform: body.examplePlatform ?? "",
      customExemplarTexts: body.customExemplarTexts ?? [],
    }),
  });
}
